module.exports = __webpack_public_path__ + "img/3.ae8bf84d.png";